export const ENVIRONMENTS_PREFIX = {
    DEV: '/dev',
    DEMO: '/demo',
    STG: '/stg',
    PRD: '',
}

export const SERVICES = {
    ADMINS: {
        DEV: 'https://x4h3imhic0.execute-api.eu-west-2.amazonaws.com',
        DEMO: 'https://cdqx87bvb7.execute-api.eu-west-2.amazonaws.com',
        STG: 'https://ph9mjks7pc.execute-api.eu-west-2.amazonaws.com',
        PRD: 'https://api.betterspace.uk/admins',
    },
    ANALYTICS: {
        DEV: 'https://mocw7100o8.execute-api.eu-west-2.amazonaws.com',
        DEMO: 'https://0txs56pbxg.execute-api.eu-west-2.amazonaws.com',
        STG: 'https://u3iu63a3kb.execute-api.eu-west-2.amazonaws.com',
        PRD: 'https://api.betterspace.uk/analytics',
    },
    CLIENTS: {
        DEV: 'https://zbzy45k9va.execute-api.eu-west-2.amazonaws.com',
        DEMO: 'https://tne5cnpcl2.execute-api.eu-west-2.amazonaws.com',
        STG: 'https://5ijcuvxe26.execute-api.eu-west-2.amazonaws.com',
        PRD: 'https://api.betterspace.uk/clients',
    },
    DASHBOARD: {
        DEV: 'https://h9soo6wnmi.execute-api.eu-west-2.amazonaws.com',
        DEMO: 'https://r7wl1xx0e8.execute-api.eu-west-2.amazonaws.com',
        STG: 'https://3jrupmr5va.execute-api.eu-west-2.amazonaws.com',
        PRD: 'https://api.betterspace.uk/dashboard',
    },
    DIRECTORY: {
        DEV: 'https://ulukc3nc9i.execute-api.eu-west-2.amazonaws.com',
        DEMO: 'https://xo7s6rvdyk.execute-api.eu-west-2.amazonaws.com',
        STG: 'https://3zm5cyjhk0.execute-api.eu-west-2.amazonaws.com',
        PRD: 'https://api.betterspace.uk/directory',
    },
    EMAIL_SUPPORT: {
        DEV: 'https://rj4263wmqj.execute-api.eu-west-2.amazonaws.com',
        DEMO: 'https://tr46whf9kc.execute-api.eu-west-2.amazonaws.com',
        STG: 'https://5kuque994m.execute-api.eu-west-2.amazonaws.com',
        PRD: 'https://api.betterspace.uk/emailsupport',
    },
    FINANCE: {
        DEV: 'https://vpdxsox4pg.execute-api.eu-west-2.amazonaws.com',
        DEMO: 'https://d2s4zgqs7e.execute-api.eu-west-2.amazonaws.com',
        STG: 'https://gfuh47j8x2.execute-api.eu-west-2.amazonaws.com',
        PRD: 'https://api.betterspace.uk/finance',
    },
    RATINGS: {
        DEV: 'https://khz3e3dygd.execute-api.eu-west-2.amazonaws.com',
        DEMO: 'https://z0528y19m4.execute-api.eu-west-2.amazonaws.com',
        STG: 'https://bsqpdo61fi.execute-api.eu-west-2.amazonaws.com',
        PRD: 'https://api.betterspace.uk/ratings',
    },
    SUPPLIERS: {
        DEV: 'https://udv5qf3v9c.execute-api.eu-west-2.amazonaws.com',
        DEMO: 'https://49qsjdsbp3.execute-api.eu-west-2.amazonaws.com',
        STG: 'https://c8bzmg0g36.execute-api.eu-west-2.amazonaws.com',
        PRD: 'https://api.betterspace.uk/suppliers',
    },
    TRANSACTIONS: {
        DEV: 'https://24ddwiekg4.execute-api.eu-west-2.amazonaws.com',
        DEMO: 'https://sxt3nogztk.execute-api.eu-west-2.amazonaws.com',
        STG: 'https://6wnq19umuj.execute-api.eu-west-2.amazonaws.com',
        PRD: 'https://api.betterspace.uk/transactions',
    },
    USER_PROFILES: {
        DEV: 'https://wqflnr91f5.execute-api.eu-west-2.amazonaws.com',
        DEMO: 'https://3ihjvqzfx0.execute-api.eu-west-2.amazonaws.com',
        STG: 'https://40byc1711d.execute-api.eu-west-2.amazonaws.com',
        PRD: 'https://api.betterspace.uk/usersProfiles',
    },
    VOUCHERS: {
        DEV: 'https://32b7wl6w1b.execute-api.eu-west-2.amazonaws.com',
        DEMO: 'https://s5bvys37mh.execute-api.eu-west-2.amazonaws.com',
        STG: 'https://ehr2ipqrq1.execute-api.eu-west-2.amazonaws.com',
        PRD: 'https://api.betterspace.uk/vouchers',
    },
    WELLBEING_ASSESSMENTS: {
        DEV: 'https://ii9woksid0.execute-api.eu-west-2.amazonaws.com',
        DEMO: 'https://qe1e134t0b.execute-api.eu-west-2.amazonaws.com',
        STG: 'https://hf4fw0pxfg.execute-api.eu-west-2.amazonaws.com',
        PRD: 'https://api.betterspace.uk/wellbeingAssessments',
    },
}
